// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallItem-module__font-s-10___T36ty {
  font-size: 10px !important;
}

.CallItem-module__font-s-12___H7vAq {
  font-size: 12px !important;
}

.CallItem-module__font-s-13___IIpsd {
  font-size: 13px !important;
}

.CallItem-module__font-s-14___LUlLC {
  font-size: 14px !important;
}

.CallItem-module__font-s-15___iH4bc {
  font-size: 15px !important;
}

.CallItem-module__font-s-16___GOi4T {
  font-size: 16px !important;
}

.CallItem-module__font-s-18___hFGTl {
  font-size: 18px !important;
}

.CallItem-module__font-s-20___yBONN {
  font-size: 20px !important;
}

.CallItem-module__font-s-22___SNJ6n {
  font-size: 22px !important;
}

.CallItem-module__font-s-28___ndK39 {
  font-size: 28px !important;
}

.CallItem-module__font-w-400___PW_Kg {
  font-weight: 400 !important;
}

.CallItem-module__font-w-500___ljIrO {
  font-weight: 500 !important;
}

.CallItem-module__font-w-600___Y4t5P {
  font-weight: 600 !important;
}

.CallItem-module__font-w-700___BzNJd {
  font-weight: 700 !important;
}

.CallItem-module__p-5___TZLJT {
  padding: 5px !important;
}

.CallItem-module__p-12___o6FQx {
  padding: 12px !important;
}

.CallItem-module__p-16___l2r54 {
  padding: 16px !important;
}

.CallItem-module__p-30___XYwIX {
  padding: 30px !important;
}

.CallItem-module__p-b-0___uBZoB {
  padding-bottom: 0 !important;
}

.CallItem-module__p-b-5___wbPCO {
  padding-bottom: 5px !important;
}

.CallItem-module__p-b-10___z5SXw {
  padding-bottom: 10px !important;
}

.CallItem-module__p-b-12___OcjjM {
  padding-bottom: 12px !important;
}

.CallItem-module__p-b-16___rfLsB {
  padding-bottom: 16px !important;
}

.CallItem-module__p-b-18___kyBeu {
  padding-bottom: 18px !important;
}

.CallItem-module__p-b-20___vCOf8 {
  padding-bottom: 20px !important;
}

.CallItem-module__p-b-25___JBz06 {
  padding-bottom: 25px !important;
}

.CallItem-module__p-b-30___NyXiZ {
  padding-bottom: 30px !important;
}

.CallItem-module__p-b-50___HaFTK {
  padding-bottom: 50px !important;
}

.CallItem-module__p-t-0___PRZ_z {
  padding-top: 0 !important;
}

.CallItem-module__p-t-12___XtI1m {
  padding-top: 12px !important;
}

.CallItem-module__p-t-16___prp8l {
  padding-top: 16px !important;
}

.CallItem-module__p-t-18___reBev {
  padding-top: 18px !important;
}

.CallItem-module__p-t-20___EJOn3 {
  padding-top: 20px !important;
}

.CallItem-module__p-t-30___kakw2 {
  padding-top: 30px !important;
}

.CallItem-module__p-t-40___zsKLa {
  padding-top: 40px !important;
}

.CallItem-module__p-t-50___KE57u {
  padding-top: 50px !important;
}

.CallItem-module__p-l-20___kw8E9 {
  padding-left: 20px !important;
}

.CallItem-module__p-l-30___pKlbD {
  padding-left: 30px !important;
}

.CallItem-module__p-l-40___jhJtp {
  padding-left: 40px !important;
}

.CallItem-module__p-r-16___KLbFp {
  padding-right: 16px !important;
}

.CallItem-module__p-r-20___AXfF6 {
  padding-right: 20px !important;
}

.CallItem-module__p-r-30___MrFxz {
  padding-right: 30px !important;
}

.CallItem-module__p-r-50___qaECx {
  padding-right: 50px !important;
}

.CallItem-module__p-r-60___hNuYP {
  padding-right: 60px !important;
}

.CallItem-module__m-b-1___nPaJs {
  margin-bottom: 1px !important;
}

.CallItem-module__m-b-2___HCMjT {
  margin-bottom: 2px !important;
}

.CallItem-module__m-b-6___W4dMt {
  margin-bottom: 6px !important;
}

.CallItem-module__m-b-8___wvt9T {
  margin-bottom: 8px !important;
}

.CallItem-module__m-b-10___dUnIy {
  margin-bottom: 10px !important;
}

.CallItem-module__m-b-14___bxZzN {
  margin-bottom: 14px !important;
}

.CallItem-module__m-b-16___TB_0I {
  margin-bottom: 16px !important;
}

.CallItem-module__m-b-20___knQKp {
  margin-bottom: 20px !important;
}

.CallItem-module__m-b-22___tS2Ji {
  margin-bottom: 22px !important;
}

.CallItem-module__m-b-24___ghkZg {
  margin-bottom: 24px !important;
}

.CallItem-module__m-b-30___W5_cE {
  margin-bottom: 30px !important;
}

.CallItem-module__m-b-32___LmJrs {
  margin-bottom: 32px !important;
}

.CallItem-module__m-b-40___H42au {
  margin-bottom: 40px !important;
}

.CallItem-module__m-t-2___WJQlw {
  margin-top: 2px !important;
}

.CallItem-module__m-t-3___AC6_c {
  margin-top: 3px !important;
}

.CallItem-module__m-t-4___zPG9U {
  margin-top: 4px !important;
}

.CallItem-module__m-t-5___oeMsh {
  margin-top: 5px !important;
}

.CallItem-module__m-t-8___CXGtP {
  margin-top: 8px !important;
}

.CallItem-module__m-t-10___vDgm5 {
  margin-top: 10px !important;
}

.CallItem-module__m-t-15___k6eja {
  margin-top: 15px !important;
}

.CallItem-module__m-t-16___BKQy8 {
  margin-top: 16px !important;
}

.CallItem-module__m-t-20___wE2t2 {
  margin-top: 20px !important;
}

.CallItem-module__m-t-22___egIfi {
  margin-top: 22px !important;
}

.CallItem-module__m-t-30___AY1xh {
  margin-top: 30px !important;
}

.CallItem-module__m-t-32___vomJr {
  margin-top: 32px !important;
}

.CallItem-module__m-l-auto___Gkiw7 {
  margin-left: auto !important;
}

.CallItem-module__m-l-4___Mk34C {
  margin-left: 4px !important;
}

.CallItem-module__m-l-5___Z1igf {
  margin-left: 5px !important;
}

.CallItem-module__m-l-6___W_OAf {
  margin-left: 6px !important;
}

.CallItem-module__m-l-8___pmlpU {
  margin-left: 8px !important;
}

.CallItem-module__m-l-10___N02xl {
  margin-left: 10px !important;
}

.CallItem-module__m-l-16___cl7IM {
  margin-left: 16px !important;
}

.CallItem-module__m-l-20___lptvp {
  margin-left: 20px !important;
}

.CallItem-module__m-l-24___HtMqj {
  margin-left: 24px !important;
}

.CallItem-module__m-l-30___Q32kQ {
  margin-left: 30px !important;
}

.CallItem-module__m-l-35___pQ_Bt {
  margin-left: 35px !important;
}

.CallItem-module__m-l-40___mMlNF {
  margin-left: 40px !important;
}

.CallItem-module__m-r-8___cT8jk {
  margin-right: 8px !important;
}

.CallItem-module__m-r-10___GTSwp {
  margin-right: 10px !important;
}

.CallItem-module__m-r-16___rm0Ys {
  margin-right: 16px !important;
}

.CallItem-module__m-r-20___Niyto {
  margin-right: 20px !important;
}

.CallItem-module__m-r-24___h2mB9 {
  margin-right: 24px !important;
}

.CallItem-module__m-r-30____knou {
  margin-right: 30px !important;
}

.CallItem-module__m-r-40___ecaHn {
  margin-right: 40px !important;
}

.CallItem-module__border-r-3___gHsw7 {
  border-radius: 3px !important;
}

.CallItem-module__border-r-4___AmX3x {
  border-radius: 4px !important;
}

.CallItem-module__border-r-6___CkJou {
  border-radius: 6px !important;
}

.CallItem-module__border-r-10___LJloV {
  border-radius: 10px !important;
}

.CallItem-module__border-r-12___A5c3K {
  border-radius: 12px !important;
}

.CallItem-module__border-r-16___JEL9f {
  border-radius: 16px !important;
}

.CallItem-module__border-r-50___qz99z {
  border-radius: 50% !important;
}

.CallItem-module__primary-border____TJMY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CallItem-module__primary-border-b___qA9NH {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CallItem-module__primary-border-t___eNBQ5 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CallItem-module__primary-border-l___Wq5b9 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CallItem-module__primary-border-r___zb00L {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CallItem-module__secondary-border___QoZlp {
  border: 1px solid #637768;
}

.CallItem-module__secondary-border-b___PDWgM {
  border-bottom: 1px solid #637768;
}

.CallItem-module__secondary-border-t___tyjwv {
  border-top: 1px solid #637768;
}

.CallItem-module__secondary-border-l___Ek5OH {
  border-left: 1px solid #637768;
}

.CallItem-module__secondary-border-r___h4UE3 {
  border-right: 1px solid #637768;
}

.CallItem-module__gap-0___BPSqv {
  gap: 0 !important;
}

.CallItem-module__gap-2___p3Gwl {
  gap: 2px !important;
}

.CallItem-module__gap-4___zGEJt {
  gap: 4px !important;
}

.CallItem-module__gap-5___D_GFR {
  gap: 5px !important;
}

.CallItem-module__gap-6___dhmcS {
  gap: 6px !important;
}

.CallItem-module__gap-8___zgEM7 {
  gap: 8px !important;
}

.CallItem-module__gap-10___H5imj {
  gap: 10px !important;
}

.CallItem-module__gap-12___SZfWF {
  gap: 12px !important;
}

.CallItem-module__gap-14___NKB8K {
  gap: 14px !important;
}

.CallItem-module__gap-16___aeZ1Y {
  gap: 16px !important;
}

.CallItem-module__gap-18___Vp2KL {
  gap: 18px !important;
}

.CallItem-module__gap-20___XXqjJ {
  gap: 20px !important;
}

.CallItem-module__gap-24___tXYqd {
  gap: 24px !important;
}

.CallItem-module__gap-26___DHKHk {
  gap: 26px !important;
}

.CallItem-module__gap-30___f3Y8A {
  gap: 30px !important;
}

.CallItem-module__gap-32___ptIyR {
  gap: 32px !important;
}

.CallItem-module__gap-40___grKDG {
  gap: 40px !important;
}

.CallItem-module__gap-50___lTeUd {
  gap: 50px !important;
}

.CallItem-module__flex-1___xhuUj {
  flex: 1;
}

.CallItem-module__flex-none___K4IHA {
  flex: none !important;
}

.CallItem-module__flex-column___D0_jB {
  display: flex;
  flex-direction: column !important;
}

.CallItem-module__flex-row___wJkMY {
  display: flex;
  flex-direction: row !important;
}

.CallItem-module__vertically-centered___laz37 {
  display: flex;
  align-items: center !important;
}

.CallItem-module__horizontally-centered___ZyTg_ {
  display: flex;
  justify-content: center !important;
}

.CallItem-module__horizontally-end___P4KC0 {
  display: flex;
  justify-content: end !important;
}

.CallItem-module__vertically-start___sUSX4 {
  display: flex;
  align-items: start !important;
}

.CallItem-module__space-between___L5zUx {
  display: flex;
  justify-content: space-between !important;
}

.CallItem-module__flex-wrap___YSyni {
  flex-wrap: wrap !important;
}

.CallItem-module__height-100___rVfAH {
  height: 100%;
}

.CallItem-module__width-50___Pnl0l {
  width: 50% !important;
}

.CallItem-module__width-100___ya_MP {
  width: 100%;
}

.CallItem-module__cursor-pointer___IIt6y {
  cursor: pointer;
}

.CallItem-module__cursor-not-allowed___T7qzD {
  cursor: not-allowed !important;
}

.CallItem-module__absolute-centered___NdKh8 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CallItem-module__absolute___fVBJ0 {
  position: absolute;
}

.CallItem-module__relative___gOZrX {
  position: relative;
}

.CallItem-module__fixed___QHMy_ {
  position: fixed;
}

.CallItem-module__visible___LVQMX {
  opacity: 1;
}

.CallItem-module__invisible___G56N2 {
  opacity: 0;
}

.CallItem-module__col-90___GKZqd {
  width: 90% !important;
}

.CallItem-module__col-auto___PausD {
  width: auto !important;
}

.CallItem-module__medical-tabs___a3737 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CallItem-module__medical-table-new___rKpWI {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CallItem-module__medical-table-new___rKpWI:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CallItem-module__medical-table-new___rKpWI::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CallItem-module__medical-table-new___rKpWI::-webkit-scrollbar-track {
  display: none;
}
.CallItem-module__medical-table-new___rKpWI.CallItem-module__no-pagination___i4NVK {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CallItem-module__medical-table-new___rKpWI.CallItem-module__no-pagination___i4NVK:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CallItem-module__medical-table-new___rKpWI.CallItem-module__no-pagination___i4NVK::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CallItem-module__medical-table-new___rKpWI.CallItem-module__no-pagination___i4NVK::-webkit-scrollbar-track {
  display: none;
}

.CallItem-module__medical-table-empty___I_gl0 {
  padding: 14px 40px !important;
}

.CallItem-module__icon-btn___QuqFG {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CallItem-module__search-icon___QlavN {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CallItem-module__disable-select___sgkCc {
  user-select: none;
}

.CallItem-module__break-word___EkRlF {
  word-break: break-word;
}

.CallItem-module__popup-clear-btn___ihIrr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CallItem-module__scroll-m-b-20___UJFIW {
  scroll-margin-bottom: 20px;
}

.CallItem-module__container___g4ESU {
  background-color: #fdfcfa;
  cursor: pointer;
}
.CallItem-module__container___g4ESU.CallItem-module__checked___g59xX {
  background-color: #f1f3e7;
}
.CallItem-module__container___g4ESU .CallItem-module__icon___iJDgu {
  align-self: flex-start;
  width: 34px;
  height: 34px;
}
.CallItem-module__container___g4ESU .CallItem-module__title___PoyqB {
  color: #a79988;
}
.CallItem-module__container___g4ESU .CallItem-module__content___QjohC {
  color: #375844;
}
.CallItem-module__container___g4ESU .CallItem-module__addition___bx2Bd {
  color: #637768;
}
.CallItem-module__container___g4ESU .CallItem-module__checkbox___wHqR4 {
  background-color: transparent;
  align-self: center;
  min-width: 140px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LinkedConversationsModule/Conversations/CallItem/CallItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,sBAAA;EACA,WAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,cAAA;AA4pBJ;AAzpBE;EACE,cAAA;AA2pBJ;AAxpBE;EACE,cAAA;AA0pBJ;AAvpBE;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(grayNew, ultra-light);\n  cursor: pointer;\n\n  &.checked {\n    background-color: get-color(greenNew, lighter);\n  }\n\n  .icon {\n    align-self: flex-start;\n    width: 34px;\n    height: 34px;\n  }\n\n  .title {\n    color: get-color(orangeNew, medium-dark);\n  }\n\n  .content {\n    color: get-color(greenNew, dark);\n  }\n\n  .addition {\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .checkbox {\n    background-color: transparent;\n    align-self: center;\n    min-width: 140px;\n    height: 20px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CallItem-module__font-s-10___T36ty`,
	"fontS12": `CallItem-module__font-s-12___H7vAq`,
	"fontS13": `CallItem-module__font-s-13___IIpsd`,
	"fontS14": `CallItem-module__font-s-14___LUlLC`,
	"fontS15": `CallItem-module__font-s-15___iH4bc`,
	"fontS16": `CallItem-module__font-s-16___GOi4T`,
	"fontS18": `CallItem-module__font-s-18___hFGTl`,
	"fontS20": `CallItem-module__font-s-20___yBONN`,
	"fontS22": `CallItem-module__font-s-22___SNJ6n`,
	"fontS28": `CallItem-module__font-s-28___ndK39`,
	"fontW400": `CallItem-module__font-w-400___PW_Kg`,
	"fontW500": `CallItem-module__font-w-500___ljIrO`,
	"fontW600": `CallItem-module__font-w-600___Y4t5P`,
	"fontW700": `CallItem-module__font-w-700___BzNJd`,
	"p5": `CallItem-module__p-5___TZLJT`,
	"p12": `CallItem-module__p-12___o6FQx`,
	"p16": `CallItem-module__p-16___l2r54`,
	"p30": `CallItem-module__p-30___XYwIX`,
	"pB0": `CallItem-module__p-b-0___uBZoB`,
	"pB5": `CallItem-module__p-b-5___wbPCO`,
	"pB10": `CallItem-module__p-b-10___z5SXw`,
	"pB12": `CallItem-module__p-b-12___OcjjM`,
	"pB16": `CallItem-module__p-b-16___rfLsB`,
	"pB18": `CallItem-module__p-b-18___kyBeu`,
	"pB20": `CallItem-module__p-b-20___vCOf8`,
	"pB25": `CallItem-module__p-b-25___JBz06`,
	"pB30": `CallItem-module__p-b-30___NyXiZ`,
	"pB50": `CallItem-module__p-b-50___HaFTK`,
	"pT0": `CallItem-module__p-t-0___PRZ_z`,
	"pT12": `CallItem-module__p-t-12___XtI1m`,
	"pT16": `CallItem-module__p-t-16___prp8l`,
	"pT18": `CallItem-module__p-t-18___reBev`,
	"pT20": `CallItem-module__p-t-20___EJOn3`,
	"pT30": `CallItem-module__p-t-30___kakw2`,
	"pT40": `CallItem-module__p-t-40___zsKLa`,
	"pT50": `CallItem-module__p-t-50___KE57u`,
	"pL20": `CallItem-module__p-l-20___kw8E9`,
	"pL30": `CallItem-module__p-l-30___pKlbD`,
	"pL40": `CallItem-module__p-l-40___jhJtp`,
	"pR16": `CallItem-module__p-r-16___KLbFp`,
	"pR20": `CallItem-module__p-r-20___AXfF6`,
	"pR30": `CallItem-module__p-r-30___MrFxz`,
	"pR50": `CallItem-module__p-r-50___qaECx`,
	"pR60": `CallItem-module__p-r-60___hNuYP`,
	"mB1": `CallItem-module__m-b-1___nPaJs`,
	"mB2": `CallItem-module__m-b-2___HCMjT`,
	"mB6": `CallItem-module__m-b-6___W4dMt`,
	"mB8": `CallItem-module__m-b-8___wvt9T`,
	"mB10": `CallItem-module__m-b-10___dUnIy`,
	"mB14": `CallItem-module__m-b-14___bxZzN`,
	"mB16": `CallItem-module__m-b-16___TB_0I`,
	"mB20": `CallItem-module__m-b-20___knQKp`,
	"mB22": `CallItem-module__m-b-22___tS2Ji`,
	"mB24": `CallItem-module__m-b-24___ghkZg`,
	"mB30": `CallItem-module__m-b-30___W5_cE`,
	"mB32": `CallItem-module__m-b-32___LmJrs`,
	"mB40": `CallItem-module__m-b-40___H42au`,
	"mT2": `CallItem-module__m-t-2___WJQlw`,
	"mT3": `CallItem-module__m-t-3___AC6_c`,
	"mT4": `CallItem-module__m-t-4___zPG9U`,
	"mT5": `CallItem-module__m-t-5___oeMsh`,
	"mT8": `CallItem-module__m-t-8___CXGtP`,
	"mT10": `CallItem-module__m-t-10___vDgm5`,
	"mT15": `CallItem-module__m-t-15___k6eja`,
	"mT16": `CallItem-module__m-t-16___BKQy8`,
	"mT20": `CallItem-module__m-t-20___wE2t2`,
	"mT22": `CallItem-module__m-t-22___egIfi`,
	"mT30": `CallItem-module__m-t-30___AY1xh`,
	"mT32": `CallItem-module__m-t-32___vomJr`,
	"mLAuto": `CallItem-module__m-l-auto___Gkiw7`,
	"mL4": `CallItem-module__m-l-4___Mk34C`,
	"mL5": `CallItem-module__m-l-5___Z1igf`,
	"mL6": `CallItem-module__m-l-6___W_OAf`,
	"mL8": `CallItem-module__m-l-8___pmlpU`,
	"mL10": `CallItem-module__m-l-10___N02xl`,
	"mL16": `CallItem-module__m-l-16___cl7IM`,
	"mL20": `CallItem-module__m-l-20___lptvp`,
	"mL24": `CallItem-module__m-l-24___HtMqj`,
	"mL30": `CallItem-module__m-l-30___Q32kQ`,
	"mL35": `CallItem-module__m-l-35___pQ_Bt`,
	"mL40": `CallItem-module__m-l-40___mMlNF`,
	"mR8": `CallItem-module__m-r-8___cT8jk`,
	"mR10": `CallItem-module__m-r-10___GTSwp`,
	"mR16": `CallItem-module__m-r-16___rm0Ys`,
	"mR20": `CallItem-module__m-r-20___Niyto`,
	"mR24": `CallItem-module__m-r-24___h2mB9`,
	"mR30": `CallItem-module__m-r-30____knou`,
	"mR40": `CallItem-module__m-r-40___ecaHn`,
	"borderR3": `CallItem-module__border-r-3___gHsw7`,
	"borderR4": `CallItem-module__border-r-4___AmX3x`,
	"borderR6": `CallItem-module__border-r-6___CkJou`,
	"borderR10": `CallItem-module__border-r-10___LJloV`,
	"borderR12": `CallItem-module__border-r-12___A5c3K`,
	"borderR16": `CallItem-module__border-r-16___JEL9f`,
	"borderR50": `CallItem-module__border-r-50___qz99z`,
	"primaryBorder": `CallItem-module__primary-border____TJMY`,
	"primaryBorderB": `CallItem-module__primary-border-b___qA9NH`,
	"primaryBorderT": `CallItem-module__primary-border-t___eNBQ5`,
	"primaryBorderL": `CallItem-module__primary-border-l___Wq5b9`,
	"primaryBorderR": `CallItem-module__primary-border-r___zb00L`,
	"secondaryBorder": `CallItem-module__secondary-border___QoZlp`,
	"secondaryBorderB": `CallItem-module__secondary-border-b___PDWgM`,
	"secondaryBorderT": `CallItem-module__secondary-border-t___tyjwv`,
	"secondaryBorderL": `CallItem-module__secondary-border-l___Ek5OH`,
	"secondaryBorderR": `CallItem-module__secondary-border-r___h4UE3`,
	"gap0": `CallItem-module__gap-0___BPSqv`,
	"gap2": `CallItem-module__gap-2___p3Gwl`,
	"gap4": `CallItem-module__gap-4___zGEJt`,
	"gap5": `CallItem-module__gap-5___D_GFR`,
	"gap6": `CallItem-module__gap-6___dhmcS`,
	"gap8": `CallItem-module__gap-8___zgEM7`,
	"gap10": `CallItem-module__gap-10___H5imj`,
	"gap12": `CallItem-module__gap-12___SZfWF`,
	"gap14": `CallItem-module__gap-14___NKB8K`,
	"gap16": `CallItem-module__gap-16___aeZ1Y`,
	"gap18": `CallItem-module__gap-18___Vp2KL`,
	"gap20": `CallItem-module__gap-20___XXqjJ`,
	"gap24": `CallItem-module__gap-24___tXYqd`,
	"gap26": `CallItem-module__gap-26___DHKHk`,
	"gap30": `CallItem-module__gap-30___f3Y8A`,
	"gap32": `CallItem-module__gap-32___ptIyR`,
	"gap40": `CallItem-module__gap-40___grKDG`,
	"gap50": `CallItem-module__gap-50___lTeUd`,
	"flex1": `CallItem-module__flex-1___xhuUj`,
	"flexNone": `CallItem-module__flex-none___K4IHA`,
	"flexColumn": `CallItem-module__flex-column___D0_jB`,
	"flexRow": `CallItem-module__flex-row___wJkMY`,
	"verticallyCentered": `CallItem-module__vertically-centered___laz37`,
	"horizontallyCentered": `CallItem-module__horizontally-centered___ZyTg_`,
	"horizontallyEnd": `CallItem-module__horizontally-end___P4KC0`,
	"verticallyStart": `CallItem-module__vertically-start___sUSX4`,
	"spaceBetween": `CallItem-module__space-between___L5zUx`,
	"flexWrap": `CallItem-module__flex-wrap___YSyni`,
	"height100": `CallItem-module__height-100___rVfAH`,
	"width50": `CallItem-module__width-50___Pnl0l`,
	"width100": `CallItem-module__width-100___ya_MP`,
	"cursorPointer": `CallItem-module__cursor-pointer___IIt6y`,
	"cursorNotAllowed": `CallItem-module__cursor-not-allowed___T7qzD`,
	"absoluteCentered": `CallItem-module__absolute-centered___NdKh8`,
	"absolute": `CallItem-module__absolute___fVBJ0`,
	"relative": `CallItem-module__relative___gOZrX`,
	"fixed": `CallItem-module__fixed___QHMy_`,
	"visible": `CallItem-module__visible___LVQMX`,
	"invisible": `CallItem-module__invisible___G56N2`,
	"col90": `CallItem-module__col-90___GKZqd`,
	"colAuto": `CallItem-module__col-auto___PausD`,
	"medicalTabs": `CallItem-module__medical-tabs___a3737`,
	"medicalTableNew": `CallItem-module__medical-table-new___rKpWI`,
	"noPagination": `CallItem-module__no-pagination___i4NVK`,
	"medicalTableEmpty": `CallItem-module__medical-table-empty___I_gl0`,
	"iconBtn": `CallItem-module__icon-btn___QuqFG`,
	"searchIcon": `CallItem-module__search-icon___QlavN`,
	"disableSelect": `CallItem-module__disable-select___sgkCc`,
	"breakWord": `CallItem-module__break-word___EkRlF`,
	"popupClearBtn": `CallItem-module__popup-clear-btn___ihIrr`,
	"scrollMB20": `CallItem-module__scroll-m-b-20___UJFIW`,
	"container": `CallItem-module__container___g4ESU`,
	"checked": `CallItem-module__checked___g59xX`,
	"icon": `CallItem-module__icon___iJDgu`,
	"title": `CallItem-module__title___PoyqB`,
	"content": `CallItem-module__content___QjohC`,
	"addition": `CallItem-module__addition___bx2Bd`,
	"checkbox": `CallItem-module__checkbox___wHqR4`
};
module.exports = ___CSS_LOADER_EXPORT___;
